import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");




export const fetchImsNat = createAsyncThunk("imsnat/allImsNat", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/allImsNat", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const imsnat = await response.json();
  return imsnat;
});



export const fetchImsNatForListe = createAsyncThunk("imsnat/allImsNatForList", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/allImsNatForList", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const imsnat = await response.json();
  return imsnat;
});



export const checkProduit = createAsyncThunk("imsnat/checkProduit", async (action) => {

  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/checkProduit", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token // Make sure 'token' is defined
    },
    body: JSON.stringify(action)
  });
  const imsnat = await response.json();
  return imsnat;
});


//upload BL file
export const saveFile = createAsyncThunk("imsnat/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const imsnat = await response.json();
  return imsnat;
});



export const verifEntete = createAsyncThunk("imsnat/verifEntete", async (action) => {
  // console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/verifEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const imsnat = await response.json();
  return imsnat;
});



export const AddedExcel = createAsyncThunk("imsnat/enteteAddedExcel", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/enteteAddedExcel", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const imsnat = await response.json();
  return imsnat;
});


// for export excel
export const fetchImsNatOnly = createAsyncThunk("imsnat/allhisImsNat", async (action) => {
  console.log(action)
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/allhisImsNat", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const imsnat = await response.json();
  return imsnat;
});



export const ImsNatDeleted = createAsyncThunk("imsnat/delete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/delete/" + action.id, {
    method: 'DELETE',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const imsnat = await response.json();
  return imsnat;
});


export const verifExistance = createAsyncThunk("imsnat/verifExistance", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "imsnat/verifExistance", {
      method: 'POST',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
      },
      body: JSON.stringify(action)
  });
  const imsnat = await response.json();
  return imsnat;
});



const imsnatReduce = createSlice({
  name: "imsnat",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
  },
  extraReducers: {
  },
});


export default imsnatReduce.reducer;